import React from 'react'
import { Link } from 'react-router-dom'
import EmailIcon from '@mui/icons-material/Email'
import RoomIcon from '@mui/icons-material/Room'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import useSiteRevampContent from '../../content/useSiteRevampContent'

const Footer = () => {
  const content = useSiteRevampContent()

  return (
    <footer id="footer-section" className="bg-footer text-white w-full">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-10 px-6 py-12 md:px-16">

        <div className="flex justify-center">
          <img src="/images/logo_leanit101.png" alt="Lean it 101" className="h-10 object-contain" />
        </div>

        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">

          {/* About column */}
          <div className="text-left">
            <p className="text-lg font-semibold text-white">Lean it 101</p>
            <hr className="mb-4 mt-4 h-[1px] border-none bg-gradient-to-r from-pyramid-19 via-pyramid-1 to-pyramid-10" />
            <p className="max-w-sm text-sm leading-7 text-slate-300">
              {content.footer.description}
            </p>
            <a
              href="https://benjaminintelligence.com"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-[8px] bg-gradient-to-r from-pyramid-1 via-pyramid-10 to-pyramid-19 px-5 py-2.5 text-sm font-semibold text-ebony transition-transform hover:-translate-y-0.5"
            >
              {content.nav.benjamin}
              <span aria-hidden="true">&#8599;</span>
            </a>
          </div>

          {/* Company column */}
          <div className="text-left">
            <p className="text-lg font-semibold text-white">{content.footer.company}</p>
            <hr className="mb-4 mt-4 h-[1px] border-none bg-gradient-to-r from-pyramid-19 via-pyramid-1 to-pyramid-10" />
            <div className="flex flex-col gap-3 text-slate-300">
              <Link className="hover:text-white" to="/">{content.footer.home}</Link>
              <Link className="hover:text-white" to="/about">{content.footer.story}</Link>
              <Link className="hover:text-white" to="/services">{content.nav.services}</Link>
              <Link className="hover:text-white" to="/how-we-work">{content.nav.howWeWork}</Link>
              <Link className="hover:text-white" to="/maestro">Maestro</Link>
              <Link className="hover:text-white" to="/platforms">{content.nav.platforms}</Link>
              <Link className="hover:text-white" to="/insights">{content.nav.insights}</Link>
              <Link className="hover:text-white" to="/speaking">{content.nav.speaking}</Link>
              <Link className="hover:text-white" to="/work-with-us">{content.footer.workWithUs}</Link>
              <a className="hover:text-white" href="mailto:contact@leanit101.com">{content.footer.contact}</a>
            </div>
          </div>

          {/* Legal column */}
          <div className="text-left">
            <p className="text-lg font-semibold text-white">{content.footer.legal}</p>
            <hr className="mb-4 mt-4 h-[1px] border-none bg-gradient-to-r from-pyramid-19 via-pyramid-1 to-pyramid-10" />
            <div className="flex flex-col gap-3 text-slate-300">
              <a className="hover:text-white" href="/politica-de-privacidade">{content.footer.privacy}</a>
              <a className="hover:text-white" href="/politica-de-protecao-aos-direitos-autorais">{content.footer.authors}</a>
              <a className="hover:text-white" href="/termos-de-uso">{content.footer.terms}</a>
            </div>
          </div>
        </div>

        {/* Contact + social */}
        <div className="grid gap-8 md:grid-cols-[1.15fr_0.85fr]">
          <div className="text-left text-slate-300">
            <a className="hover:text-white" href="https://goo.gl/maps/WvgABfhARFqtAHAC8" rel="noopener noreferrer" target="_blank">
              <span className="inline-flex items-start gap-3 leading-7">
                <RoomIcon className="mt-1" />
                <span>{content.footer.address}</span>
              </span>
            </a>
            <div className="mt-4">
              <a className="hover:text-white inline-flex items-center gap-3" href="mailto:contact@leanit101.com">
                <EmailIcon />
                <span>contact@leanit101.com</span>
              </a>
            </div>
          </div>

          <div className="flex items-center justify-start gap-3 md:justify-end">
            <a className="hover:text-white" href="https://www.linkedin.com/company/11737282/" rel="noopener noreferrer" target="_blank">
              <LinkedInIcon />
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-4 text-center text-sm italic text-slate-400">
          &copy; 2026 Lean it 101. {content.footer.copyright}
        </div>
      </div>
    </footer>
  )
}

export default Footer
